import type { usePlayerStore } from '~/stores/usePlayerStore'

/** Bonus or farm persistés (maîtrise compte + Pokédex région) — aligné snapshot serveur. */
export function snapshotFarmGoldBonusMult(player: ReturnType<typeof usePlayerStore>): number {
  return (
    player.currentZoneMasteryGoldMult * player.pokedexGoldMultForGen(player.activeCombatGen)
  )
}
